<template>
    <Modal
        v-model="show"
        title="总监角色部门信息"
        :width="60"
        @on-visible-change="onShowChange"
    >
        <Spin v-if="$globalSpin" size="large" fix></Spin>
        <Form
            ref="modelForm"
            :model="modelForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form"
        >
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="选择角色" prop="roleId">
                        <Select v-model="modelForm.roleId" filterable clearable>
                            <Option
                                v-for="item in roleList"
                                :key="item.roleUuid"
                                :value="item.roleUuid"
                                :label="item.name"
                            >
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择公司" prop="projectCompany">
                        <Select
                            v-model="modelForm.projectCompany"
                            @on-change="onCompanyChange"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in companyList"
                                :key="item.projectCompany"
                                :value="item.projectCompany"
                                :label="item.projectCompany"
                            >
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择部门(支持多选)" prop="seedFarmIds">
                        <Select
                            v-model="modelForm.seedFarmIds"
                            filterable
                            multiple
                            clearable
                        >
                            <Option
                                v-for="item in deptList"
                                :key="item.seedFarmUuid"
                                :value="item.seedFarmUuid"
                                :label="item.seedFarmName"
                            ></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="状态" prop="recordStatus">
                        <RadioGroup
                            v-model="modelForm.recordStatus"
                            type="button"
                        >
                            <Radio
                                v-for="item in statusSource"
                                :key="item.val"
                                :label="item.val"
                                >{{ item.label }}
                            </Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary" @click="onSave">确认</Button>
            <Button type="error" @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { STATUS_YES, STATUS_NO, statusNewFormat } from "@/libs/baseModelFormat";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";

import {
    getRoleList,
    getInspectorCompanyList,
    getInspectorDeptList,
    batchAddRoleSeedFarm
} from "@/api/modules/account-management/inspector-user-management";

export default {
    name: "RoleDeptInspectorEdit",
    data() {
        return {
            mode: "add",
            show: false,
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                roleId: "",
                projectCompany: "",
                seedFarmIds: [],
                recordStatus: STATUS_YES
            },
            ruleValidate: {
                roleId: [
                    { required: true, message: "roleId ", trigger: "blur" }
                ],
                projectCompany: [
                    {
                        required: true,
                        message: "projectCompany ",
                        trigger: "blur"
                    }
                ],
                seedFarmIds: [
                    {
                        required: true,
                        message: "部门不能为空",
                        type: "array",
                        trigger: "blur"
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 0) {
                                callback();
                            }
                            else {
                                callback(new Error("请选择部门"));
                            }
                        },
                        trigger: "blur"
                    }
                ]
            },
            statusSource: [],
            roleList: [],
            companyList: [],
            deptList: []
        };
    },
    mounted() {},
    methods: {
        onShowChange(e) {
            if (e && this.mode == "add") {
                this.init();
            }
            this.getInfo();
        },
        showModal(
            mode = "add",
            roleId = "",
            projectCompany = "",
            seedFarmIds = "",
            recordStatus = ""
        ) {
            this.mode = mode;
            this.$refs.modelForm.resetFields();
            this.show = true;
            if (mode != "add") {
                this.$set(this.modelForm, "roleId", roleId);
                this.$set(this.modelForm, "seedFarmIds", seedFarmIds);
                this.$set(this.modelForm, "recordStatus", recordStatus);
            }
        },
        init() {
            this.$refs.modelForm.resetFields();
        },
        getInfo() {
            this.statusSource = [];
            this.statusSource.push({
                val: STATUS_YES,
                label: statusNewFormat(STATUS_YES)
            });
            this.statusSource.push({
                val: STATUS_NO,
                label: statusNewFormat(STATUS_NO)
            });
            this.getRoleList();
            this.getCompanyList();
        },
        getRoleList() {
            getRoleList({
                type: "总监"
            }).then((res) => {
                if (res.code === 0) {
                    this.roleList = res.data.records.filter(
                        (x) => x.userStatus == 1
                    );
                }
                else {
                    this.roleList = [];
                }
            });
        },
        getCompanyList() {
            getInspectorCompanyList().then((res) => {
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
                else {
                    this.companyList = [];
                }
            });
        },
        onCompanyChange() {
            if (this.modelForm.projectCompany) {
                getInspectorDeptList({
                    projectCompany: this.modelForm.projectCompany
                }).then((res) => {
                    if (res.code === 0) {
                        this.deptList = res.data.records;
                    }
                    else {
                        this.deptList = [];
                    }
                });
            }
            else {
                this.deptList = [];
            }
        },
        onSave() {
            this.$refs.modelForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }
                const data = Object.assign(
                    {
                        formEditMode: this.formEditMode
                    },
                    this.modelForm
                );

                this.$showGlobalSpin();
                batchAddRoleSeedFarm(data).then((res) => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            //this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped></style>
